/**
 * Schema of ResponsavelFilial
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import ResponsavelFilial from '@/model/resource/ResponsavelFilial'

export default (model: ResponsavelFilial): Schema => ({
  idFilialPk: {
    content: model.idFilialPk,
    editable: false,
  },

  cnpjBase: {
    content: model.cnpjBase,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },
})
